export * from "/app/node_modules/@toctoc/design-system/dist/esm/index.js"